import { render, staticRenderFns } from "./IconSMSBalance.vue?vue&type=template&id=40fc7304"
import script from "./IconSMSBalance.vue?vue&type=script&lang=js"
export * from "./IconSMSBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports